export default "__VITE_ASSET__B$5_WyVX__"